import { render, staticRenderFns } from "./addAssets.vue?vue&type=template&id=1f34d196&scoped=true&"
import script from "./addAssets.vue?vue&type=script&lang=js&"
export * from "./addAssets.vue?vue&type=script&lang=js&"
import style0 from "./addAssets.vue?vue&type=style&index=0&id=1f34d196&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f34d196",
  null
  
)

export default component.exports